import React, { useEffect, useState } from "react";
import DcaCalculator from "./components/DcaCalculator";
import ProfileSelector from "./components/ProfileSelector";
import "./index.css";

function App() {
    const [profile, setProfile] = useState(null);

    // Tự động khôi phục profile từ localStorage
    useEffect(() => {
        const stored = localStorage.getItem("currentProfile");
        if (stored) setProfile(stored);
    }, []);

    const handleSelectProfile = (name) => {
        setProfile(name);
        localStorage.setItem("currentProfile", name);
    };

    const handleLogout = () => {
        setProfile(null);
        localStorage.removeItem("currentProfile");
    };

    return (
        <div className="min-h-screen bg-gray-100 font-bevietnam p-4">
            {!profile ? (
                <ProfileSelector onSelect={handleSelectProfile} />
            ) : (
                <>
                    <div className="text-right text-sm mb-2">
                        🔐 {profile} |{" "}
                        <button
                            onClick={handleLogout}
                            className="text-blue-600 underline"
                        >
                            Đăng xuất
                        </button>
                    </div>
                    <DcaCalculator profileName={profile} />
                </>
            )}
        </div>
    );
}

export default App;
